import { Component, OnInit } from '@angular/core';
import { SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  standalone: false
})
export class TermsAndConditionsComponent implements OnInit {
  Images = IMAGES;
  SupportEmail = SUPPORT_EMAIL;

  constructor() { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

}
